import React from 'react';
import TimePickerProps from '../TimePicker/types';
import TimePicker from '../TimePicker';

const TimePickerHour: React.FC<TimePickerProps> = ({
  id,
  label,
  labelId,
  value,
  onFieldChange,
  ...props
}) => {
  const hours = Array.from({ length: 24 }, (_, i) => ({
    id: i.toString().padStart(2, '0'),
    name: i.toString().padStart(2, '0'),
  }));

  return (
    <TimePicker
      id={id}
      label={label}
      labelId={labelId}
      values={hours}
      value={value}
      onChange={(event) => onFieldChange?.(event)}
      {...props}
    />
  );
};

export default TimePickerHour;
